module.exports = __webpack_public_path__ + "img/resolt.241c2935.png";